module.exports = __webpack_public_path__ + "assets/successNote2Speck2-e557d3.svg";